const PNG_PREFIX = 'data:image/png;base64,';

export type SignaturePadExport = {
  isEmpty: () => boolean;
  toDataURL: (type?: string) => string;
  getTrimmedCanvas: () => HTMLCanvasElement;
};

export function exportSignaturePngDataUrl(pad: SignaturePadExport | null): string | null {
  if (!pad || pad.isEmpty()) return null;
  try {
    const trimmed = pad.getTrimmedCanvas().toDataURL('image/png');
    if (trimmed.startsWith(PNG_PREFIX) && trimmed.length > PNG_PREFIX.length) return trimmed;
  } catch {
    // getTrimmedCanvas throws when the pad has no ink in some browsers
  }
  const raw = pad.toDataURL('image/png');
  if (raw.startsWith(PNG_PREFIX) && raw.length > PNG_PREFIX.length) return raw;
  return null;
}
